import React from "react";
import styled from "styled-components";
import NavbarBrand from "./NavbarBrand";
import NavbarLink from "./NavbarLink";
import Button from "../Button/Button";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import icon from "@fortawesome/fontawesome-free-solid/faBars";

class Navbar extends React.Component {
  constructor(props) {
    super(props);
  }
  location() {
    if (window.location.search.substr(1)) {
      return window.location.pathname + "?" + window.location.search.substr(1);
    }
    return window.location.pathname;
  }
  render() {
    return (
      <nav className={this.props.className}>
        <Button ghost className="menu">
          <FontAwesomeIcon icon={icon} />
        </Button>
        <NavbarBrand src={this.props.logo} alt={this.props.logoAlt} />
        {this.props.links.map((link, i) => (
          <NavbarLink
            href={link.url ? link.url : false}
            active={link.url === this.location() ? true : false}
            key={i}
          >
            {link.title}
          </NavbarLink>
        ))}
      </nav>
    );
  }
}

export default styled(Navbar)`
  background-color: ${props =>
    props.instance === "CEJIL"
      ? "#c3112f"
      : props.instance === "Zorlakay"
        ? "#86b004"
        : props.instance === "CLEEN"
          ? "#010066"
          : props.instance === "aot"
            ? "#064e80"
            : props.instance === "tchrd"
              ? "#006400"
              : props.instance === "tgeu"
                ? "#7b003e"
                : "#60748b"};
  background-image: ${props =>
    props.instance === "CEJIL"
      ? "url(https://sidh.cejil.org/public/header-background.png)"
      : false};
  background-repeat: ${props =>
    props.instance === "CEJIL"
      ? "no-repeat"
      : props.instance === "tgeu"
        ? "no-repeat"
        : ""};
  background-position: ${props =>
    props.instance === "CEJIL"
      ? "right center"
      : props.instance === "tgeu"
        ? "right center"
        : ""};
  position: fixed;
  width: 100%;
  top: 0;
  padding: 0 16px;
  background-size: auto 48px;
  display: flex;
  align-items: center;
  margin: 0;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px -1px,
    rgba(0, 0, 0, 0.06) 0px 4px 5px 0px, rgba(0, 0, 0, 0.08) 0px 1px 10px 0px;
  z-index: 1;

  @media (max-width: 959px) {
    ${NavbarLink} {
      display: none;
    }
  }
  @media (min-width: 960px) {
    .menu {
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/UI/Navbar/Navbar.js